import { FileHistoryPaginationCriteria } from "../objects/fileHistoryPaginationCriteria";

export const EMPTY_FILE_HISTORY_PAGINATION_CRITERIA: FileHistoryPaginationCriteria = {
    page: 0,
    rows_per_page: [5, 10, 25, 50],
    limit: 50,
}